import { ITransportEstimationResult } from './transport-estimation-result.model';

export class CurrentUserBasket {
  id?: number;
  transportPrice: number = 0;
  gazoleTax: number = 0; // Sum gazoleTax transport
  insurance: number = 0;
  priceHT: number = 0;
  vatRate: number = 0;
  price: number = 0;
  vat: number = 0;
  transports: ITransportEstimationResult[] = [];
  carbonFootprint: number = 0;

  constructor(data: any = {}) {
    Object.assign(this, data);
  }

  get basePrice(): number {
    return this.transports.reduce((price, it) => price + it.estimation.basePrice, 0);
  }

  get pricingOptions(): number {
    return this.transports.reduce((price, it) => price + (it.estimation.pricingOptions ? it.estimation.pricingOptions.reduce((p, o) => p + o.amount, 0) : 0), 0);
  }
}
